<script>
import axios from 'axios'
import eventBus from '@/eventBus.js'
import BaseModal from '@/components/_common/modal/BaseModal'
import DeviceSelector from '@/components/clinic/DeviceSelector'
import BreadcrumbNavigation from '@/components/_common/BreadcrumbNavigation'
import { mapGetters } from 'vuex'
export default {
  name: 'TheTopBar',
  components: {
    BaseModal,
    DeviceSelector,
    BreadcrumbNavigation
  },
  data () {
    return {
      resetNameKey: 0, // increment key to wipe new name value in device selector
      showDeviceSelector: false,
      appVersion: null
    }
  },
  computed: {
    ...mapGetters({
      userDevice: 'user/userDevice',
      userInfo: 'user/userInfo',
      actualAppUserInfo: 'user/actualAppUserInfo',
      sidenavState: 'application/sidenavState',
      clipboardState: 'application/clipboardState',
      calibrationEnabled: 'user/calibrationEnabled',
      isHomePatient: 'user/isHomePatient'
    }),
    showUserScope () {
      return (
        this.$store.state.user.actualAppUserInfo !== null &&
        this.$store.state.user.actualAppUserInfo.appUserId !== this.$store.state.user.userInfo.appUserId &&
        (this.$store.state.user.scopeAppUserInfo ? this.$store.state.user.scopeAppUserInfo.appUserId !== this.$store.state.user.userInfo.appUserId : true)
      )
    },
    isDemoMode () {
      return this.$store.state.user.scopeAppTenant !== null
    },
    showNavToggle () {
      // if sidenav is hidden
      // if not on MyDashboard page UNLESS $mq = mobile
      let showNav = ((this.sidenavState === 'HIDDEN') && (this.$route.name !== 'MyDashboard'))
      if (this.$route.name === 'MyDashboard') {
        showNav = (this.$mq === 'mobile')
      }
      return showNav
    },
    showLogoutInBar () {
      return ((!this.showUserScope) && (this.$mq !== 'mobile'))
    },
    demoTenantName () {
      const t = this.$store.state.user.scopeAppTenant
      return t ? t.name : ''
    },
    isShadowingUser () {
      return this.$store.state.user.actualAppUserInfo !== null && !this.isDemoMode
    },
    shadowUserName () {
      const u = this.$store.state.user.userInfo
      return u ? `${u.firstName} ${u.lastName}` : ''
    },
    shadowUserEmail () {
      const u = this.$store.state.user.userInfo
      return u ? (u.recoveryEmail || u.username) : ''
    },
    sidenavAriaLabel () {
      const labelFrag = 'side navigation'
      return this.sidenavState === 'ACTIVE' ? `Hide ${labelFrag}` : `Show ${labelFrag}`
    },
    deviceButtonLabel () {
      return this.userDevice ? 'Change' : 'Set Device'
    },
    deviceLabel () {
      return this.userDevice ? this.userDevice.label : 'no device set'
    },
    showVersion () {
      return this.appVersion && (this.$userHasPermission('p:super-admin') || this.$userHasPermission('p:ovb-activity-developer'))
    },
    versionLabel () {
      if (!this.appVersion) return ''
      const v = `v${this.appVersion.version}`
      if (this.appVersion.date) {
        const d = new Date(this.appVersion.date)
        const formatted = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
        return `${v} \u00B7 ${formatted}`
      }
      return v
    }
  },
  watch: {
    // calibrationEnabled (val) {
    //   if (!val) {
    //     this.removeDevice()
    //   }
    // }
  },
  methods: {
    removeDevice () {
      // remove device as persistent cookie
      const expirationDate = new Date(0).toUTCString()
      let cookieString = ''
      const deviceString = 'ovbDeviceId=;'
      cookieString = deviceString + 'samesite=strict, Secure; path=/; expires=' + expirationDate
      document.cookie = cookieString
      // remove device in vuex users/setDevice
      this.$store.dispatch('user/setUserDevice', null)
    },
    onChangeDevice () {
      this.resetNameKey += 1
      this.showDeviceSelector = true
    },
    closeDeviceSelector () {
      this.showDeviceSelector = false
    },
    toggleSideNav () {
      let payload
      switch (this.sidenavState) {
        case 'ACTIVE':
          payload = 'HIDDEN'
          break
        case 'HIDDEN':
          payload = 'ACTIVE'
          break
        default:
      }
      this.$store.dispatch('application/setSidenavState', payload)
    },
    toggleClipboard () {
      let payload
      switch (this.clipboardState) {
        case 'ACTIVE':
          payload = 'HIDDEN'
          break
        case 'HIDDEN':
          payload = 'ACTIVE'
          break
        default:
      }
      this.$store.dispatch('application/setClipboardState', payload)
    },
    checkDeviceCookie (name) {
      const match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'))
      return match ? match[1] : null
    },
    exitDemo () {
      this.$store.dispatch('CLEAR_SCOPE_APP_TENANT')
    },
    exitShadow () {
      this.$store.dispatch('STOP_IMPERSONATION')
    },
    async fetchVersion () {
      try {
        const { data } = await axios.get('/api/app/version')
        this.appVersion = data
      } catch (e) {
        // silently ignore — badge just won't show
      }
    },
    async logout () {
      // Show global loading overlay and navigate immediately
      await this.$store.dispatch('application/setGlobalLoading', {
        show: true,
        message: 'Logging you out...'
      })
      // Navigate immediately to PreLogout which handles the actual logout
      this.$router.push({ name: 'PreLogout' })
    }
  },
  mounted () {
    eventBus.$on('SET_USER_DEVICE', () => {
      this.showDeviceSelector = true
    })
    const deviceCookie = this.checkDeviceCookie('ovbDeviceId')
    if (deviceCookie) {
      this.$store.dispatch('user/setUserDevice', deviceCookie)
    }
    this.fetchVersion()
  },
  beforeDestroy () {
    eventBus.$off('SET_USER_DEVICE')
  }
}
</script>
<template>
  <div
    class="the-top-bar"
  >
    <div
      class="container top-bar-container"
    >
      <div
        class="top-bar-items"
      >
        <div
          class="top-bar-item"
        >
          <transition
            name="fade"
            mode="out-in"
          >
            <button
              v-if="showNavToggle"
              aria-expanded="false"
              class="sidenav-toggle button mr-4"
              @click="toggleSideNav"
              aria-label="toggle game clipboard"
            >
              <span class="icon is-large">
                <i
                  class="mdi mdi-menu mdi-36px"
                  aria-hidden="true"
                />
              </span>
            </button>
          </transition>
        </div>
        <div
          class="breadcrumb-container"
          :class="{'nav-hidden': sidenavState === 'HIDDEN'}"
        >
          <breadcrumb-navigation />
        </div>
<!--        <div-->
<!--          class="top-bar-item"-->
<!--        >-->
<!--          <span class="is-family-semibold ml-4">{{ $mq }}</span>-->
<!--        </div>-->
        <div class="top-bar-right">
          <div v-if="isShadowingUser" class="top-bar-item shadow-user-indicator">
            <span class="icon is-small mr-1"><i class="mdi mdi-account-eye" /></span>
            <span class="shadowing-label">Shadow: <strong>{{ shadowUserName }}</strong> ({{ shadowUserEmail }})</span>
            <a class="shadowing-exit ml-2" @click="exitShadow">Exit</a>
          </div>
          <div v-if="isDemoMode" class="top-bar-item shadowing-indicator">
            <span class="icon is-small mr-1"><i class="mdi mdi-eye-outline" /></span>
            <span class="shadowing-label">Shadowing <strong>{{ demoTenantName }}</strong></span>
            <a class="shadowing-exit ml-2" @click="exitDemo">Exit</a>
          </div>
          <div
            v-if="showVersion"
            class="top-bar-item version-badge is-hidden-mobile"
          >
            <span class="has-text-grey is-size-7">{{ versionLabel }}</span>
          </div>
          <template v-if="calibrationEnabled">
            <!-- Mobile ------------------------- -->
            <div class="top-bar-item device-selection is-hidden-tablet">
              <div class="vertical-align-items">
                <span class="icon is-small has-text-gray-dark mr-1"><i class="mdi mdi-18px mdi-monitor-cellphone"/></span>
                <span class="has-text-gray-dark mr-1">Device:</span>
                <template v-if="userDevice">
                  <span class="is-family-semibold">{{ userDevice.name }}</span>
                </template>
                <template v-else>
                  <span class="has-text-danger is-family-semibold">None set</span>
                </template>
              </div>
              <div>
                <a @click="onChangeDevice">
                  [ {{ deviceButtonLabel }} ]
                </a>
              </div>
            </div>
            <!-- Tablet Plus ------------------------- -->
            <div class="top-bar-item device-selection is-hidden-mobile">
              <div class="vertical-align-items">
                <span class="icon is-small has-text-gray-dark mr-1"><i class="mdi mdi-18px mdi-monitor-cellphone"/></span>
                <span class="has-text-gray-dark mr-1">Device:</span>
                <template v-if="userDevice">
                  <span class="is-family-semibold">{{ userDevice.name }}</span>
                </template>
                <template v-else>
                  <span class="has-text-danger is-family-semibold">None set</span>
                </template>
              </div>
              <div>
                <a @click="onChangeDevice" class="ml-2">
                  [ {{ deviceButtonLabel }} ]
                </a>
              </div>
            </div>
          </template>
          <template v-if="showLogoutInBar">
            <button
              class="button is-primary is-outlined ml-4"
              @click="logout"
            ><span class="icon is-medium mr-1">
          <i class="mdi mdi-18px mdi-logout" />
        </span>
              <span class="is-family-semibold">Log Out</span>
            </button>
          </template>
        </div>
      </div>
    </div>
    <base-modal
      name="SelectDevice"
      :close-on-mask-click="true"
      :has-close-button="true"
      :show="showDeviceSelector"
      :has-footer="false"
      @CLOSE_MODAL="closeDeviceSelector"
    >
      <template #header>
        Select or Add your Device
      </template>
      <template #content>
        <div>
          <device-selector
            v-if="calibrationEnabled"
            :reset-name-key="resetNameKey"
            @CLOSE_MODAL="closeDeviceSelector"
          />
        </div>
      </template>
    </base-modal>
  </div>
</template>

<style lang="scss" scoped>
  .the-top-bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 1;
    //padding: 0 2rem 0 0.5rem;
    background-color: $beige;
    button.button.clipboard-toggle {
      background-color: transparent;
      border: none;
      border-radius: 0;
      i {
        color: $primary;
      }
    }
    .top-bar-container {
      //background-color: #cb5fae;
      flex-grow: 1;
      margin: 0 auto;
      position: relative;
      width: auto;
    }
    .top-bar-items {
      display: flex;
      align-items: center;
      padding: 0 1rem;
    }
    .breadcrumb-container {
      display: inline-flex;
      align-items: center;
      margin-left: 0;
      transition: all 0.3s ease-in-out;
      //&.nav-hidden {
      //  margin-left: 1rem;
      //}
    }
    .top-bar-right {
      display: flex;
      flex-grow: 1;
      justify-content: flex-end;
    }
    .top-bar-item {
      display: inline-flex;
      align-items: center;
    }
    .device-selection {
      display: flex;
      flex-wrap: wrap;
      line-height: 1rem;
      justify-content: flex-end;
    }
    .shadow-user-indicator {
      background-color: rgba(255, 152, 0, 0.12);
      border: 1px solid rgba(255, 152, 0, 0.4);
      border-radius: 20px;
      padding: 0.2rem 0.75rem;
      margin-right: 0.75rem;
      font-size: 0.8rem;
      color: #e65100;
      .shadowing-label {
        white-space: nowrap;
      }
      .shadowing-exit {
        color: #e65100;
        font-weight: 600;
        text-decoration: underline;
        &:hover {
          color: #bf360c;
        }
      }
    }
    .shadowing-indicator {
      background-color: rgba(50, 115, 220, 0.1);
      border: 1px solid rgba(50, 115, 220, 0.3);
      border-radius: 20px;
      padding: 0.2rem 0.75rem;
      margin-right: 0.75rem;
      font-size: 0.8rem;
      color: #3273dc;
      .shadowing-label {
        white-space: nowrap;
      }
      .shadowing-exit {
        color: #3273dc;
        font-weight: 600;
        text-decoration: underline;
        &:hover {
          color: #1a5cc8;
        }
      }
    }
    .version-badge {
      margin-right: 1rem;
      opacity: 0.7;
    }
  }
</style>
